import ClAppButton from "../ClAppButton/ClAppButton";
import './ClCard.css';

const BtnCard = function (tlt, value, action, pExtraOpts, contentProjected = null) {

    let props = {
        instance: null,
        extraOpts: {
            highlight: 'full',// none, full, content, label,
            ...pExtraOpts
        }
    }

    const setStyleOpts = (cardEle) => {
        const { extraOpts } = props;
        if (extraOpts.highlight !== 'none')
            cardEle?.classList.add(`cl-card-item-highlight--${(
                { full: 'full', content: 'content', none: 'none' })[extraOpts.highlight || 'full']}`);
    }

    const createEle = async () => {
        const item = document.createElement('li');
        const cardTltEle = document.createElement('span');
        item.classList.add('cl-btn-card-item');
        cardTltEle.textContent = tlt;
        cardTltEle.classList.add('cl-btn-card-item__tlt');
        setStyleOpts(item);
        // content to be projected on card
        if (contentProjected) {
            item.appendChild(contentProjected || document.createElement('span'));
        } else {
            const newBtn = ClAppButton(`cl-btn-card-${Date.now()}`, [], {
                lbl: tlt,
                styleType: 'custom-outline-lg',
                btnType: 'button',
                customStyleSttgs: { bg: 'transparent', color: '#828282' },
                icon: {
                    pos: props.extraOpts?.icon?.pos === ('down' || 'right') && 'right'
                        || props.extraOpts?.icon?.pos === ('up' || 'left') && 'left'
                        || 'left',
                    value: value
                    // value: imgResource
                },
                stack: 'v',
                align: props.extraOpts?.align
            });
            item.appendChild(newBtn.build());
        }
        // 
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(item);
            }, 10);
        });
    }

    const build = async () => {
        const newCard = await createEle();
        if (action) newCard.onclick = (e) => action({
            listWrapp: newCard.parentElement.parentElement,
            value: value,
            e: e
        });
        return newCard;
    }

    return {
        build
    };
}

export default BtnCard;